import { createSelector } from 'reselect';

import { getActiveTipPolicyId } from 'selectors/session';

export const getLocationEligibleForPurchase = state =>
  state.getIn(['tipPoolingPolicies', 'locationEligibleForPurchase']);

export const getCurrentPayrollPeriod = state =>
  state.getIn(['tipPoolingPolicies', 'currentPayrollPeriod']);

export const getPreviousPayrollPeriod = state =>
  state.getIn(['tipPoolingPolicies', 'previousPayrollPeriod']);

export const getLocationRoles = state =>
  state.getIn(['tipPoolingPolicies', 'locationRoles']);

export const getDataIsLoading = state =>
  state.getIn(['tipPoolingPolicies', 'isLoading']);

export const getTipPoolingPolicies = state =>
  state.getIn(['tipPoolingPolicies', 'tipPoolingPolicies']);

export const showCreatedModal = state =>
  state.getIn(['tipPoolingPolicies', 'showCreatedModal']);

export const showRequestCallModal = state =>
  state.getIn(['tipPoolingPolicies', 'showRequestUnsubscribeCallModal']);

export const showRequestCallSuccessModal = state =>
  state.getIn(['tipPoolingPolicies', 'showRequestUnsubscribeCallSuccessModal']);

export const getWithinBusinessHours = state =>
  state.getIn(['tipPoolingPolicies', 'withinBusinessHours']);

export const showTipPoolDisabledAlert = state =>
  state.getIn(['tipPoolingPolicies', 'showTipPoolDisabledAlert']);

export const showTipPoolEnabledAlert = state =>
  state.getIn(['tipPoolingPolicies', 'showTipPoolEnabledAlert']);

export const showTipPoolUpdatedAlert = state =>
  state.getIn(['tipPoolingPolicies', 'showTipPoolUpdatedAlert']);

export const getTipPoolEffectiveDate = state =>
  state.getIn(['tipPoolingPolicies', 'tipPoolEffectiveDate']);

export const getShowNewRoleAddedSuccessAlert = state =>
  state.getIn(['tipPoolingPolicies', 'showNewRoleAddedSuccessAlert']);

export const getIsSubscribedToTipPooling = state =>
  state.getIn(['tipPoolingPolicies', 'subscribed']);

export const getTipPoolingPrice = state =>
  state.getIn(['tipPoolingPolicies', 'price']);

export const getLocationEligibleForPos = state =>
  state.getIn(['tipPoolingPolicies', 'locationEligibleForPos']);

export const getTipPoolingSources = state =>
  (state.getIn(['tipPoolingPolicies', 'tipPoolingSources']) || []).sort(
    (a, b) => a.get('display_order') - b.get('display_order')
  );

export const getActiveTipPolicy = createSelector(
  getTipPoolingPolicies,
  getActiveTipPolicyId,
  (tipPoolingPolicies, activeTipPolicyId) => {
    if (tipPoolingPolicies?.toJS)
      tipPoolingPolicies = tipPoolingPolicies?.toJS();
    return tipPoolingPolicies?.find(policy => policy.id === activeTipPolicyId);
  }
);

export const getImportTipsFromPos = createSelector(
  getActiveTipPolicy,
  activeTipPolicy => activeTipPolicy?.import_from_pos
);

export const getActiveTipPolicyEditableSourceTypes = createSelector(
  getActiveTipPolicy,
  getTipPoolingSources,
  (activeTipPolicy, tipPoolingSources) => {
    if (!activeTipPolicy || !tipPoolingSources) return [];

    const all_policy_sources = activeTipPolicy.all_policy_sources
      .filter(s => !s.archived_at)
      .map(s => s.tip_pooling_source_id);

    return tipPoolingSources
      .toJS()
      .filter(source => all_policy_sources.includes(source.id))
      .map(source => source.source_type);
  }
);

export const getTipPolicyById = createSelector(
  getTipPoolingPolicies,
  tipPoolingPolicies => tipId => {
    if (!tipPoolingPolicies) return null;
    if (tipPoolingPolicies?.toJS)
      tipPoolingPolicies = tipPoolingPolicies?.toJS();
    return tipPoolingPolicies?.find(policy => policy.id === tipId);
  }
);

export const getTipPolicyFrequency = createSelector(
  getActiveTipPolicy,
  activeTipPolicy => activeTipPolicy?.frequency
);
